import {mergeAttributes} from "@tiptap/core";
import Italic from "@tiptap/extension-italic";

// Preserve <i> tags for italics
export const CustomItalics_i = Italic.extend({
	name: "italic",
	parseHTML() {
		return [
			{
				tag:      "i",
				getAttrs: node => (node as any).style.fontStyle !== "normal" && null
			},
			{
				style: "font-style=italic"
			}
		];
	},
	renderHTML({HTMLAttributes}) {
		return ["i", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
	}
});
